import React from 'react';
import {allApplications} from '../applications/ApplicationList.js';
import '../desktop-components-css/DesktopIcon.css';

function IconGrid(props) {
  return (
      <div id="iconGrid">
        {allApplications.map((value, index) => {
          if(value.windowType === "Application") {
            return (
              <DesktopIcon
                icon = {value.bigIcon}
                appLauncherHandler = {props.appLauncherHandler}
                appName = {value.name}
                filename = {null}
                key={index}
              />
            );
          }
          else {
            return(null);
          }
        })}
      </div>
  );
}

function DesktopIcon(props) {
  let buttonTitle = "desktop-" + props.appName
  let buttonTextTitle = "desktop-text-" + props.appName
  return (
    <div id="desktopIcon">
      <div>
        <img
          data-testid={buttonTitle}
          src={props.icon}
          draggable="false"
          alt={props.appName}
          onDoubleClick= {e => props.appLauncherHandler(e, props.appName, null, props.filename)}/>
        <p data-testid={buttonTextTitle} onDoubleClick= {e => props.appLauncherHandler(e, props.appName, null, props.filename)}>{props.appName}</p>
      </div>
    </div>
  );
}

export default IconGrid;
